// extracted by mini-css-extract-plugin
export default {"menu":"users_menu__xhLYV","search":"users_search__nvKbp"};